import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  record(event) {
    const action = event.currentTarget?.dataset?.readerActivityAction
    if (!action || !window.crypto?.randomUUID) return

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    if (!csrfToken) return

    window.dispatchEvent(new CustomEvent("reader-activity:recorded", { detail: { action } }))

    fetch("/reader_activity", {
      method: "POST",
      credentials: "same-origin",
      keepalive: true,
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken
      },
      body: JSON.stringify({
        meaningful_action: action,
        idempotency_key: `web-${window.crypto.randomUUID()}`,
        occurred_at: new Date().toISOString()
      })
    }).catch(() => undefined)
  }
}
